import React from "react";
import { Navigate } from "react-router-dom";
import Courier from "./../pages/Order/courier";

const courierRoutes = [
  { path: "/", element: <Courier /> },
  { path: "*", element: <Navigate to="/" /> },
];
export default courierRoutes;
